export default __webpack_public_path__ + "static/4-0f17bcd24e54bff13bf61c955ef006f8.jpeg";